import EmblaCarousel from 'embla-carousel'
import A11y from '@bluecadet/embla-carousel-a11y'
import { addPrevNextBtnsClickHandlers } from './prevNextBtns.js'
import { initCarouselInert } from './carouselInert.js'
import { reducedMotion } from '../../utils/breakpoints.js'
import { resetImageZoom } from '../imageZoom.js'

export const carouselInit = (scope = document) => {
    const carousels = [...scope.querySelectorAll('.js-carousel')]
    if (!carousels.length) return
    console.log('Initializing carousels', carousels)

    carousels.forEach((carousel) => {
        if (carousel._embla) return

        const viewport = carousel.querySelector('.js-carousel-viewport')
        const slides = [...carousel.querySelectorAll('.js-carousel-slide')]
        const prevButton = carousel.querySelector('.js-carousel-prev')
        const nextButton = carousel.querySelector('.js-carousel-next')
        const activeMq = carousel.dataset.carouselActiveMq
        const mediaQueryList = activeMq ? window.matchMedia(activeMq) : null

        if (!viewport || slides.length === 0) return

        const options = {
            ...(activeMq ? { active: false, breakpoints: { [activeMq]: { active: true } } } : {}),
            loop: false,
            inViewThreshold: 0.25,
            // Slides still change instantly on prev/next/drag - only the
            // smooth scrolling motion between them is skipped.
            duration: reducedMotion.matches ? 0 : 25,
        }

        const emblaApi = EmblaCarousel(viewport, options, [A11y()])
        carousel._embla = emblaApi
        let isDragEnabled = true

        initCarouselInert(emblaApi)

        const applyStartIndex = () => {
            const rawIndex = carousel.dataset.carouselStartIndex
            if (rawIndex == null) return

            const startIndex = Number.parseInt(rawIndex, 10)
            if (Number.isNaN(startIndex)) return

            emblaApi.scrollTo(startIndex, true)
        }

        const setCarouselState = (isScrollable) => {
            carousel.classList.toggle('is-carousel', isScrollable)
            carousel.classList.toggle('is-static', !isScrollable)
            prevButton?.classList.toggle('hidden', !isScrollable)
            nextButton?.classList.toggle('hidden', !isScrollable)
        }

        const setDragState = (shouldEnableDrag) => {
            if (isDragEnabled === shouldEnableDrag) return

            isDragEnabled = shouldEnableDrag
            emblaApi.reInit({
                ...options,
                watchDrag: shouldEnableDrag,
            })
        }

        const updateCarouselState = () => {
            if (mediaQueryList && !mediaQueryList.matches) {
                setCarouselState(false)
                setDragState(false)
                return
            }

            const isScrollable = emblaApi.canScrollPrev() || emblaApi.canScrollNext()
            setCarouselState(isScrollable)
            setDragState(isScrollable)
        }

        const resetZoomOnSelect = () => {
            if (!carousel.closest('.js-modal-content-wrapper')) return
            resetImageZoom()
        }

        emblaApi.on('init', applyStartIndex)
        emblaApi.on('init', updateCarouselState)
        emblaApi.on('select', resetZoomOnSelect)
        emblaApi.on('reInit', applyStartIndex)
        emblaApi.on('resize', updateCarouselState)
        emblaApi.on('reInit', updateCarouselState)
        mediaQueryList?.addEventListener('change', updateCarouselState)

        let removePrevNextHandlers = null
        if (prevButton && nextButton) {
            removePrevNextHandlers = addPrevNextBtnsClickHandlers(emblaApi, prevButton, nextButton)
        }

        emblaApi.on('destroy', () => {
            mediaQueryList?.removeEventListener('change', updateCarouselState)
            removePrevNextHandlers?.()
            carousel._embla = null
        })
    })
}

carouselInit()
